import * as React from "react";

import { Typography, WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import { TextStyle } from "@material-ui/core/styles/createTypography";

type ClassNames = "text";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    text: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale"
    }
});

type Variant = "footnote" | "body" | "important" | "quote" | "title1" | "title2" | "title3" | "title4";

interface TextProps {
    variant?: Variant,
    align?: "inherit" | "left" | "center" | "right" | "justify",
    gutterBottom?: boolean,
    color?: "inherit",
    style?: React.CSSProperties,
    className?: string
}

const variantMap: {[key: string]: TextStyle} = {
    "footnote": "caption",
    "body": "body1",
    "important": "body2",
    "quote": "headline",
    "title1": "display1",
    "title2": "display2",
    "title3": "display3",
    "title4": "display4"
};

export class Text extends React.Component<WithStyles<ClassNames> & TextProps> {

    public static defaultProps: Partial<TextProps> = {
        variant: "body",
        align: "inherit",
        gutterBottom: true
    };

    public render() {
        const {classes, gutterBottom, variant: type, align, color, style, children, className} = this.props;
        const variant = variantMap[type as Variant];
        return (
            <Typography className={`${classes.text} ${className}`} {...{align, variant, gutterBottom, style, color}}>
                {children}
            </Typography>
        );
    }
}

export default withStyles(styles)<TextProps>(Text);



// WEBPACK FOOTER //
// ./src/components/Text.tsx